import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api/client";

/** A Slack workspace connected for the member's company. */
export interface SlackWorkspace {
  app_id: string;
  team_id: string;
  team_name: string;
}

export const SLACK_WORKSPACES_KEY = ["slack-workspaces"] as const;

/** The company's connected Slack workspaces — empty when none (or on error). */
export function useSlackWorkspaces() {
  return useQuery({
    queryKey: SLACK_WORKSPACES_KEY,
    queryFn: async () => {
      try {
        const res = await api.get("/tenant-portal/slack-bot-info/");
        return (res.data.bots ?? res.data) as SlackWorkspace[];
      } catch {
        return [] as SlackWorkspace[];
      }
    },
  });
}
